import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [otpVerification, setOtpVerification] = useState(false);
  const [email, setEmail] = useState("");

  return (
    <AuthContext.Provider value={{ otpVerification,setOtpVerification, email, setEmail }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
